import "@scss/main.scss"

import "lazysizes"
import 'lazysizes/plugins/respimg/ls.respimg'
import { makeBrowserDetector } from "@js/modules/browserDetector"
import { slideUp, slideDown } from 'es6-slide-up-down'
import{ easeInOutCubic } from 'es6-easings'
import ASScroll from '@ashthornton/asscroll'
import Highway from '@dogstudio/highway'

import HomeRenderer from '@js/renderers/HomeRenderer'
import PageRenderer from '@js/renderers/PageRenderer'
import ResourceRenderer from '@js/renderers/ResourceRenderer'
import GlobalRenderer from '@js/renderers/GlobalRenderer'

import DefaultTransition from '@js/transitions/DefaultTransition'

import store from '@js/modules/store'
import Animizi from '@js/libs/Animizi'
import Scrollino from '@js/libs/Scrollino'
import Loadizi from '@js/libs/Loadizi'

document.addEventListener('DOMContentLoaded', function(){
	// Loader
	store.loader = new Loadizi('.o-body_loader')

	// ASScroll init
	if(window.innerWidth >= 1024) {
		store.asscroll = new ASScroll({
			ease: 0.18,
			disableRaf: true
		})
	}

	store.highway = false
	new Promise(resolve => {
		store.loader.progress(100, document.body.classList.contains('-loggedIn') ? 0 : 1.5, resolve)
	}).then(() => {
		return new Promise(resolve => {
			store.loader.hide(resolve)
		})
	}).then(() => {
		// Highway
		store.highway = new Highway.Core({
			renderers: {
				home: HomeRenderer,
				resource: ResourceRenderer,
				page: PageRenderer
			},
			transitions: {
				default: DefaultTransition
			}
		})
		store.globalRenderer = new GlobalRenderer

		// Enable asscroll
		if(window.innerWidth >= 1024) {
			store.asscroll.enable()
		}

		// Active menu
		store.highway.on('NAVIGATE_IN', ({ to, location }) => {
			// Remove old classes
			if(document.querySelector('.m-navMain .-activeTrail'))
				document.querySelector('.m-navMain .-activeTrail').classList.remove('-activeTrail')
			if(document.querySelector('.m-navMain .is-active'))
				document.querySelector('.m-navMain .is-active').classList.remove('is-active')

			// Add new class
			const link = document.querySelector(`.m-navMain a[href="${location.pathname}"]`)
			if(link) {
				link.classList.add('is-active')
				if(link.classList.contains('m-navMain_link')) {
					link.parentNode.classList.add('-activeTrail')
				} else {
					link.parentNode.parentNode.parentNode.classList.add('-activeTrail')
				}
			}

			// recaptcha
			if(document.querySelector('#webform-submission-contact-node-19-add-form .g-recaptcha')) {
				window.grecaptcha.render(document.querySelector('#webform-submission-contact-node-19-add-form .g-recaptcha'));
			}
		})
	})

	// Reload page on resize : not clean sorry
	const isDesktop = window.innerWidth >= 1280
	window.onresize = () => {
		if(isDesktop && window.innerWidth < 1280) {
			location.reload()
		} else if(!isDesktop && window.innerWidth >= 1280) {
			location.reload()
		}
	}

	// Get footer
	store.footer = document.querySelector('.o-footer')

	// Resize observer
	if(window.innerWidth >= 1024) {
		const resizeObserver = new ResizeObserver(store.asscroll.resize)
		resizeObserver.observe(document.querySelector('div[asscroll]'))
	}

	// Scroll direction
	if(window.innerWidth >= 1024) {
		store.scrollino = new Scrollino(store.asscroll)
	} else {
		store.scrollino = new Scrollino()
	}

	// The location on the page is not restored, user will need to scroll manually.
	if(window.innerWidth >= 1024) {
		window.history.scrollRestoration = 'manual'
	}

	// Animizi
	if(window.innerWidth >= 1024)
		store.animizi = new Animizi()

	// Burger menu
	if(window.innerWidth < 1280) {
		document.querySelector('.a-burger').addEventListener('click', () => {
			document.body.classList.toggle('-menu')
		})
	}

	// Mobile sub menus
	if(window.innerWidth < 1280) {
		document.querySelectorAll('.m-navMain_item.-expanded').forEach(item => {
			item.querySelector('.m-navMain_link').addEventListener('click', e => {
				e.preventDefault()
				// Close opened sub menus
				document.querySelectorAll('.m-navMain_sub').forEach(sub => {
					if(sub.style.display == 'block') {
						slideUp(sub, {
							duration: 600,
							easing: easeInOutCubic
						})
					}
				})
				document.querySelectorAll('.m-navMain_item.-opened').forEach(item => {
					item.classList.remove('-opened')
				})
				// Open or close clicked sub menu
				if(item.querySelector('.m-navMain_sub').style.display != 'block') {
					slideDown(item.querySelector('.m-navMain_sub'), {
						duration: 600,
						easing: easeInOutCubic
					})
					item.classList.add('-opened')
				} else {
					slideUp(item.querySelector('.m-navMain_sub'), {
						duration: 600,
						easing: easeInOutCubic
					})
					item.classList.remove('-opened')
				}
			})
		})
	}

	if(window.innerWidth >= 1280) {
		// Menu hover
		document.querySelector('.m-navMain').addEventListener('mouseover', () => {
			document.body.classList.add('-menuHover')
		})
		document.querySelector('.m-navMain').addEventListener('mouseout', () => {
			document.body.classList.remove('-menuHover')
		})
		// Sub menu hover
		document.querySelectorAll('.m-navMain_item.-expanded').forEach(item => {
			item.addEventListener('mouseover', () => {
				document.body.classList.add('-subMenuHover')
			})
			item.addEventListener('mouseout', () => {
				document.body.classList.remove('-subMenuHover')
			})
		})
	}

	// Disable highway on language link
	document.querySelectorAll('.o-header_lang a').forEach(link => {
		link.dataset.routerDisabled = 1
	})

	// Footer logo click
	document.querySelector('.o-footer_logo').addEventListener('click', e => {
		if(window.innerWidth >= 1024) {
			if(store.highway.From.properties.slug == 'home')
				store.asscroll.scrollTo(0)
		} else {
			window.scrollTo(0, 0);
		}
	})

	// Hide contentinfo on click
	const contentinfo = document.querySelector('form .contentinfo')
	if (contentinfo) {
		const popup = document.querySelector('.a-popup')
		if(contentinfo.querySelector('.webform-confirmation-modal--title'))
			popup.querySelector('.a-popup_title').innerHTML = contentinfo.querySelector('.webform-confirmation-modal--title').innerHTML
		if(contentinfo.querySelector('.webform-confirmation-modal--content'))
			popup.querySelector('.a-popup_content').innerHTML = contentinfo.querySelector('.webform-confirmation-modal--content').innerHTML
		// Show popup
		popup.classList.remove('-hidden')
		// Close events
		popup.querySelector('.a-popup_close').addEventListener('click', () => {
			popup.classList.add('-hidden')
		})
		popup.querySelector('.a-btn').addEventListener('click', e => {
			e.preventDefault()
			popup.classList.add('-hidden')
		})
	}

})

// Cookiebot
window.addEventListener('load', () => {
	const opener = document.querySelector("a[href='#cookies']");
	if(opener && typeof window.Cookiebot !== "undefined"){
		opener.addEventListener("click", e => {
			e.preventDefault();
			window.Cookiebot.renew();
		});
	}

	const preventLenisOnCookiebotDialog = () => {
		if (document.querySelector("#CybotCookiebotDialog")) {
			document.querySelector(
				"#CybotCookiebotDialog"
			).classList.add("asscroll-block");
		}
		if (document.querySelector("#CybotCookiebotDialogBodyUnderlay")) {
			document.querySelector(
				"#CybotCookiebotDialogBodyUnderlay"
			).classList.add("asscroll-block");
		}
	};

	if (document.querySelector("#CybotCookiebotDialog")) {
		preventLenisOnCookiebotDialog();
	}

	// Add lenisPrevent on first display
	const mutationCallback = function (mutationsList) {
		mutationsList.forEach(mutation => {
			if (mutation.type === "childList") {
				mutation.addedNodes.forEach(node => {
					if (
						node.id === "CybotCookiebotDialog" ||
						node.id === "CybotCookiebotDialogBodyUnderlay"
					) {
						preventLenisOnCookiebotDialog();
					}
				});
			}
		});
	};
	const observer = new MutationObserver(mutationCallback);
	observer.observe(document.body, { childList: true, subtree: true });
});

// register CSS classes on <html> to help with browser detection in CSS
makeBrowserDetector(window).bootstrapClasses()

// SWPL LOG
console.log(
	"%c swimmingpool ",
	`background: #1467ff;
	color: white;
	font-size: 14px;
	font-weight: bold;
	line-height: 36px; text-align: center`,
	" www.swpl.fr"
);
